import { useState } from 'react'

import { useQuery } from 'providers/tanstack-query/useQuery'
import { workspaceFromDTO } from './api/mapper'
import { GET_WORKSPACE_FOR_FORM } from './api/query'
import { Data, Variables } from './api/types'
import { UseGetWorkspace, UseGetWorkspaceProps, WorkspaceSlice } from './types'

export const useGetWorkspace = ({ id }: UseGetWorkspaceProps): UseGetWorkspace => {
  const [workspace, setWorkspace] = useState<WorkspaceSlice>()

  const { isLoading: loading } = useQuery<Variables, Data>({
    onCompleted: async (data: Data) => {
      const { node: workspace } = data

      if (workspace) {
        setWorkspace(workspaceFromDTO(workspace))
      }
    },
    options: {
      enabled: id !== undefined,
    },
    query: GET_WORKSPACE_FOR_FORM,
    variables: {
      id: id!,
    },
  })

  return { loading, workspace }
}
